//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prodGrp2Menu', {
//        templateUrl: 'views/components/views/prodGrp2Menu/prodGrp2Menu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'prodGrp2MenuService', 'ttGridFactory', function ($stateParams, stateService, prodGrp2MenuService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodGrp2Id = $stateParams.prodgrp2_id;

//            vm.model = {
//                menu: {},
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_prodgrp2menu_prodgrp3_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'prodgrp2menu_new',
//                    text: 'prodgrp2menu_new',
//                    func: () => {
//                        stateService.go('prodgrp3', {
//                        	prodgrp2_id: vm.model.menu.prodgrp2_id,
//                        	prodgrp3_id: '+'
//                        });
//                    },
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await prodGrp2MenuService.getMenu({ prodgrp2_id: prodGrp2Id }))[0];
                
//                loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3074,
//                    parameters: { prodgrp2_id: vm.model.menu.prodgrp2_id }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//            	loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
